import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer'
import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import useFareCards from '@/src/hooks/itinerary/useFareCards'
import { Box, Divider } from '@mui/material'
import { useTranslations } from 'next-intl'
import VasForFareFamily from './vasForFareFamily'

const VasForFareFamilyWrapper = () => {
    const {
        faresToDisplay,
        onFareSelect,
        formatFareTitle,
        onViewBenefits,
        benefitsDrawerOpen,
        benefitsUrl,
        closeBenefitsDrawer
    } = useFareCards()
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const t = useTranslations('common')

    if (!Array.isArray(faresToDisplay) || !faresToDisplay.length) {
        return null
    }

    return (
        <>
            <Divider sx={{ mt: { xs: 0, lg: 3 }, mb: { xs: 0, lg: 2 }, display: { xs: 'none', lg: 'block' } }} />
            <VasForFareFamily
                fares={faresToDisplay}
                onFareSelect={onFareSelect}
                formatFareTitle={formatFareTitle}
                formatCurrency={formatCurrency}
                t={t}
                onViewBenefits={onViewBenefits}
            />
            {benefitsDrawerOpen && (
                <SwipeableDrawerWithBackNavigation
                    open={benefitsDrawerOpen}
                    onClose={closeBenefitsDrawer}
                    sx={{ zIndex: 1400, display: { xs: 'block', lg: 'none' } }}
                >
                    <Box sx={{ flex: 1, minHeight: 0 }}>
                        {benefitsUrl && (
                            <iframe
                                src={benefitsUrl}
                                style={{ border: 'none', width: '100%', height: '100%' }}
                                title="View Benefits"
                            />
                        )}
                    </Box>
                </SwipeableDrawerWithBackNavigation>
            )}
        </>
    )
}

export default VasForFareFamilyWrapper